export default __webpack_public_path__ + "static/Tek_Generator-8800403020a8b51b4715192bbca81b5c.png";